var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.125c7 0 8.556 4.765 8.902 6.882.088.545-.35.993-.902.993H4c-.552 0-.99-.448-.901-.993.345-2.117 1.9-6.882 8.901-6.882zm0 1.5c-3.119 0-4.836 1.042-5.83 2.15-.786.875-1.207 1.889-1.43 2.725h14.52c-.223-.836-.644-1.85-1.43-2.726-.994-1.107-2.71-2.149-5.83-2.149zM12 3a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 1.5a3 3 0 100 6 3 3 0 000-6z",
    fill: "currentColor"
  })));
}
SvgAccount.displayName = 'Account';
export default SvgAccount;